export default __webpack_public_path__ + "static/media/lb-qs.6ad67231.webp";